import { Copy } from 'lucide-react';
import { useState } from 'react';

export default function PromoBar() {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText('ESYFREE');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="promo-bar">
      Free Delivery on Orders Above &#8377;999 | Use Code:
      <button onClick={handleCopy} className="code" style={{ cursor: 'pointer', border: 'none' }}>
        {copied ? 'Copied!' : 'ESYFREE'}
        <Copy size={14} />
      </button>
    </div>
  );
}
